import { validationMixin } from "vuelidate";
import { VueSlideToggle } from "vue-slide-toggle";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    mixin: [validationMixin],
    name: "edit-form-address",
    props: ["address", "isEdit"],

    data() {
        return {
            secondAddresses: [],
            payload: {
                active: "",
                city: "",
                street: "",
                house: "",
                flat: "",
                id: "",
            },
            validationErrors: {},
        };
    },
    components: {
        VueSlideToggle,
    },
    validations: {
        payload: {
            city: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(30),
            },
            street: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(50),
            },
            house: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(8),
            },
            flat: {
                required,
                minLength: minLength(1),
                maxLength: maxLength(8),
            },
        },
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax").replace(":count", 30));
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.flat.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    watch: {
        // user: function (newVal) {
        //   if (newVal) {
        //     this.secondAddresses=[]
        //     for (let i in this.user.addresses) {
        //       if (this.user.addresses[i].active === 0) {
        //         this.secondAddresses.push(this.user.addresses[i]);
        //       }
        //     }
        //   }
        // },
    },
    created() {
        // console.log(this.address);
        this.payload.city = this.address.city;
        this.payload.flat = this.address.flat;
        this.payload.house = this.address.house;
        this.payload.street = this.address.street;
        this.payload.id = this.address.id;
        this.payload.active = this.address.active;

        // for (let i in this.user.addresses) {
        //   if (this.user.addresses[i].active === 0) {
        //     this.secondAddresses.push(this.user.addresses[i]);
        //   }
        // }
        // console.log(this.secondAddresses)
    },
    methods: {
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
        }),
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            editUserAddress: `profile/EDIT_USER_ADDRESS`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
        }),
        removeAddress() {
            let obj = {};
            obj.id = this.address.id;
            this.showLoader = true;
            this.deleteUserAddress(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youAddressRemove"));
                    this.fetchUserData();
                    this.$emit("close", "false");
                    // this.showLoader = false;
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        // this.showLoader = false;
                    }
                });
        },
        cancelEdit() {
            this.payload.city = this.address.city;
            this.payload.street = this.address.street;
            this.payload.house = this.address.house;
            this.payload.flat = this.address.flat;
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.$emit("close", "false");
        },
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.city = this.payload.city;
            obj.street = this.payload.street;
            obj.house = this.payload.house;
            obj.flat = this.payload.flat;
            obj.id = this.payload.id;
            obj.active = this.payload.active;
            if (!this.$v.$invalid) {
                this.editUserAddress(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("youAddressRefresh"));
                        this.fetchUserData();
                        this.$emit("close", "false");
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showLoader = false;
                            this.isEdit = true;
                        }
                    });
            }
        },
    },
};
